import type { DragEndEvent } from '@dnd-kit/core';
import type { PipelineEtapa } from '@/types/gestaoLicitacoes';

export const PIPELINE_ETAPAS: PipelineEtapa[] = ['captacao', 'em_analise', 'em_disputa', 'ganha', 'perdida'];

export const ETAPA_LABELS: Record<PipelineEtapa, string> = {
  captacao: 'Captação',
  em_analise: 'Em análise',
  em_disputa: 'Em disputa',
  ganha: 'Ganha',
  perdida: 'Perdida',
};

export function handleDragEnd(
  event: DragEndEvent,
  onMover: (args: { activeId: string; etapa: PipelineEtapa }) => void
) {
  const { active, over } = event;
  if (!over) return;

  const etapa = String(over.id) as PipelineEtapa;
  if (!PIPELINE_ETAPAS.includes(etapa)) return;

  onMover({ activeId: String(active.id), etapa });
}
